import { Button, Col, Form, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import Panel from '../../../../shared/components/card/Panel';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { GUTTOR_SPACE } from '../../../../shared/constants/commonConstants';
import { getPreviousUrl } from '../../../crm/inPatient/service/crmUtils';
import { FormInstance } from 'antd/lib/form/Form';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import PayerList from '../../../../shared/components/payerList/PayerList';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';
import { PayerInitialState } from '../../../../store/models/payerListModel';
import BeneficiarySearch from '../../../crm/inPatient/newAdmission/panels/BeneficiarySearch/BeneficiarySearch';
import CaseDetails from './caseDetails/CaseDetails';
import HeaderRightAction from './HeaderRightAction/HeaderRightAction';
import BuddhiMedFileUploadModal from '../../../../shared/components/fileUpload/buddhimedFileUploadModal/BuddhiMedFileUploadModal';
import { fetchLookUpValues } from '../../../../store/actions/lookUpAction';
import {clearNewAdmissionState, setAdmissionForm, setIsLoadingPreData, setIsShowAdmissionForm, setSelectedBeneficiary } from '../../../../store/actions/newAdmissionAction';
import { generateOTP, resetReimbursement, setOTPModalVisible, submitAdmission } from '../../../../store/actions/reimbursementAction';
import SuccessModal from './SuccessModal';
import OTPModal from './OTPModal';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import { changePayer } from '../../../../store/actions/payerListAction';
import { Payer } from '../../../../shared/models/payer.model';
import { centeredNotification } from '../../../../utils/utility';

const NewAdmissionReimbursement = ({ match, location: { pathname }}: any, form: FormInstance): ReactElement | null => {
  const [hospitalWisePayer, setHospitalWisePayer] = useState([]);
  const dispatch = useDispatch();
  const {
    admissionFormVal,
    hospitalWisePayerList,
    selectedBeneficiaryDetail,
    isShowAdmissionForm,
    newAdmissionSearchValues,
   } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { payer } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const [baseForm] = Form.useForm();
  const [admissionForm] = Form.useForm();
  const { isOTPModalVisible } = useSelector((state: RootState): any => state.reimbursement);
  const [buddhimedForm] = Form.useForm();
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [OTPToken, setOTPToken] = useState('');
  const [isBackPressed, setIsBackPressed] = useState(false);
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  useEffect((): void => {
      setHospitalWisePayer(hospitalWisePayerList);
  }, [hospitalWisePayerList, admissionFormVal]);

  useEffect((): void => {
    if (selectedBeneficiaryDetail) {
      admissionForm.setFieldsValue({
        corporateName: selectedBeneficiaryDetail.policyHolderName,
        emailId: selectedBeneficiaryDetail.memberEmailId,
        fullName: selectedBeneficiaryDetail.memberName,
        memberId: selectedBeneficiaryDetail.memberId,
        policyNumber: selectedBeneficiaryDetail.policyNo,
      });
    }
  }, [selectedBeneficiaryDetail]);

  useEffect((): void => {
    if (newAdmissionSearchValues) {
      admissionForm.setFieldsValue({
        fullName: newAdmissionSearchValues?.fullName ? newAdmissionSearchValues?.fullName : null,
        memberId: newAdmissionSearchValues?.memberId ? newAdmissionSearchValues?.memberId : null,
        policyNumber: newAdmissionSearchValues?.policyNumber ? newAdmissionSearchValues?.policyNumber : null,
        corporateName: newAdmissionSearchValues?.corporateName ? newAdmissionSearchValues?.corporateName : null,
      });
    }
  }, [newAdmissionSearchValues]);

  const lookUpSuccessCallback = (): void => {
      dispatch(setIsLoadingPreData(false));
  };
  useEffect((): void => {
    if (payer.id) {
      dispatch(fetchLookUpValues(lookUpSuccessCallback, payer.uniqueIdentifier));
    }
  }, [payer]);

  const onSuccess = (): any => {
    setIsSuccessModalVisible(true);
    form.resetFields();
    buddhimedForm.resetFields();
  };

  useEffect((): any => {
    return (): void => {
      window.onbeforeunload = (): void => {
        setIsBackPressed(true);
        setIsSuccessModalVisible(false);
        dispatch(setOTPModalVisible(false));
        dispatch(setIsShowAdmissionForm(false));
        dispatch(changePayer({} as Payer));
      };
    };
  });

  useEffect((): void => {
    setIsSuccessModalVisible(false);
    dispatch(setOTPModalVisible(false));
    dispatch(setIsShowAdmissionForm(false));
    dispatch(setSelectedBeneficiary({}));
    dispatch(changePayer({} as Payer));
    dispatch(setAdmissionForm({}));
    dispatch(resetReimbursement());
    dispatch(clearNewAdmissionState());
  }, []);

  const onError = (errorMessage: string, duplicateClaimDetails: any): void => {
  };
  const onOTPSuccessSubmit = (): void => {
    dispatch(setOTPModalVisible(false));
    dispatch(submitAdmission(admissionForm, false, onSuccess, onError));
  };
  const onFileUploadSubmit = (): void => {
    const formValues = (admissionForm.getFieldsValue());
    if (buddhimedForm.getFieldsValue()?.kyc) {
      if (!formValues.fullName?.trim() || !formValues.mobile?.trim() || !formValues.memberId?.trim() ||
      !formValues.emailId?.trim() || !formValues.dateOfAdmission || !formValues.dateOfDischarge ||
      !formValues?.stayLength || !formValues.procedure?.trim() || !formValues.claimedAmount?.trim()) {
        centeredNotification('Please enter all required details');
      } else if (formValues.claimedAmount && formValues.claimedAmount <= 0) {
        centeredNotification('Claim Amount cannot be 0');
      } else {
        if (formValues.mobile) {
          dispatchOTP();
        } else {
          centeredNotification('Please enter mobile number of patient');
        }
      }
    }
  };

  const dispatchOTP = (): void => {
    const payload = {
      phoneNumber: (admissionForm.getFieldsValue()).mobile,
      providerId: appdetails.getProviderId(),
    };
    dispatch(generateOTP(payload, onOTPGenerateSuccess, onOTPGenerateError));

  };

  const onOTPGenerateSuccess = (encryptedToken: string): void => {
    setOTPToken(encryptedToken);
    dispatch(setOTPModalVisible(true));
  };

  const onOTPGenerateError = (): void => {
  };
  return(
    <React.Fragment>
      <PageHeader customeClass="mt-lg" pageTitle="New Admission" backUrl={getPreviousUrl(pathname)}
      rightComponent={(): ReactElement => (
        <HeaderRightAction
          form={admissionForm}
          isShowAdmissionForm={isShowAdmissionForm}
        />
      )}
      />

      <div className="ant-tabs-content-holder tab-custom-container pb-0"
        data-testid="new-admission">
        <Row gutter={GUTTOR_SPACE}>
          <Col md={24}>
            {
              <Form
                form={baseForm}
                requiredMark="optional"
                layout="vertical"
              >
                <Panel className="mb-md">
                  <Row gutter={GUTTOR_SPACE}>
                    <PayerList {...{
                      size: 24,
                      form: baseForm,
                      hideLabel: false,
                      data: hospitalWisePayer?.length ? hospitalWisePayer : undefined,
                    }} />

                  {payer?.isClaimSubmissionDisabled &&
                    <Col md={24} className="text-right">
                      <Button type="primary"
                        onClick={(): void => {
                          window.open(
                            JSON.parse(payer?.payerReDirectionDtails || '{}').link,
                            '_blank',
                          );
                        }}>
                        {
                          JSON.parse(payer?.payerReDirectionDtails || '{}')?.lable ||
                          'Redirect to Payer'
                        }
                      </Button>
                    </Col>
                  }
                  </Row>
                </Panel>
              </Form>
            }
            {
              payer.id > 0 && !isBackPressed &&
                <>
                  {
                    !isShowAdmissionForm &&
                    <BeneficiarySearch prefillOldData={false} />
                  }
                  {
                    isShowAdmissionForm &&
                    <CaseDetails form={admissionForm} title="Enter Case Details" />
                  }
                </>
            }
          </Col>
        </Row>
      </div>
      { isSuccessModalVisible &&
        <SuccessModal isModalVisible={isSuccessModalVisible} setIsModalVisible={setIsSuccessModalVisible}/>
      }
      {
        isOTPModalVisible &&
        <OTPModal onOTPSuccessSubmit={onOTPSuccessSubmit} form={admissionForm} dispatchOTP={dispatchOTP}
        OTPToken={OTPToken}className="display-none"/>
      }
      <BuddhiMedFileUploadModal
        admissionForm={baseForm}
        form={buddhimedForm}
        onSuccessSubmit={onFileUploadSubmit}
        isReimbursementModule={true}
      />
    </React.Fragment>
  );
};

export default NewAdmissionReimbursement;
